import heroBg from '../assets/images/hero_bg.png';
import logo from '../assets/images/logo.png';
import logo_white from '../assets/images/logo_white.png';
import auth_bg from '../assets/images/auth_bg.png';

const images = {
    heroBg,
    logo,
    logo_white,
    auth_bg,
};

export default images;
